import type { DuplicateActionPlan, DuplicateChoice } from './aiChatTypes'

export function planDuplicateAction(
  choice: DuplicateChoice,
  tool?: { id: number; name: string; title?: string },
): DuplicateActionPlan {
  if (choice === 'continue') return { approve: true }
  if (!tool?.id) return { approve: false }
  if (choice === 'forward') return { approve: false, navigateTo: `/toolslist/${tool.id}` }
  return { approve: false, cloneOf: tool }
}

export function cloneTitle(title?: string, name?: string): string {
  return `${title ?? name ?? 'Tool'} (Copy)`
}

export const DUPLICATE_RESOLUTION_LABELS: Record<DuplicateChoice, string> = {
  forward: '- Opened existing tool',
  duplicate: '- Duplicated — editing a copy',
  continue: '- Building a new tool',
}
